import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Hidden, withStyles } from '@material-ui/core'
import MobileForm from './MobileForm'
import DesktopForm from './DesktopForm'
import { receiveContact, ingestPrediction } from 'actions/contacts/addOrEdit'
import { getContact, getCustomAttributes } from 'actions/contacts'
import { consumePrediction } from 'actions/predictions'
import AddDetailsModal from './AddDetailsModal'
import { getAllGroups } from 'actions/contacts/groups'

export default connect(
  (state, { match, contactID }) => {
    let contact = null

    if (contactID) {
      contact = state.contacts.contactsWithEmailsByID[contactID] || null
    }
    if (match?.params?.contactID) {
      contact =
        state.contacts.contactsWithEmailsByID[match.params.contactID] || null
    }

    return {
      contact,
      createContact: state.predictions.createContact
        ? state.predictions.createContact
        : null,
    }
  },
  dispatch =>
    bindActionCreators(
      {
        receiveContact,
        getContact,
        ingestPrediction,
        consumePrediction,
        getAllGroups,
        getCustomAttributes,
      },
      dispatch,
    ),
)(
  withStyles(theme => ({
    // ...other styles for the pages
    content: {
      padding: 24,
      [theme.breakpoints.down('sm')]: {
        // padding: maybe something else for 'sm' size,
      },
      [theme.breakpoints.down('xs')]: {
        padding: 0,
      },
    },
  }))(
    class AddOrEditContactPage extends Component {
      componentDidMount() {
        console.log('AddOrEditContactPage componentDidMount()')

        const {
          match,
          getContact,
          contact,
          receiveContact,
          contactID,
          // inbox,
          getAllGroups,
          getCustomAttributes,
        } = this.props

        // console.log(contactID)
        // console.log(match)
        // console.log(contact)

        getAllGroups()
        getCustomAttributes()

        if (
          (contactID && contactID !== 'new') ||
          match?.params?.contactID !== 'new'
        ) {
          console.log('hits if (contactID && contactID !== new) || ...')
          // console.log('hits if')
          const id = contactID || match?.params?.contactID

          if (contact) {
            console.log('hits if (contact) {...')
            receiveContact(contact).then(() => {
              console.log('hits receiveContact(contact).then(...')
              // if (!inbox) {
              getContact(id).then(payload => {
                console.log('hits getContact(id).then(...')
                receiveContact(payload)
              })
              // }
            })
          } /* if (!inbox) */ else {
            getContact(id).then(payload => receiveContact(payload))
          }
        }
        this.handlePrediction()
      }

      componentDidUpdate(prevProps) {
        // console.log('prevProps:')
        // console.log(prevProps)
        // console.log('')
        // console.log('this.props:')
        // console.log(this.props)
        console.log('AddOrEditContactPage.componentDidUpdate')
        if (
          (this.props.contactID &&
            prevProps.contactID !== this.props.contactID) ||
          prevProps?.location?.pathname !== this.props?.location?.pathname
        ) {
          console.log('AddOrEditContactPage.componentDidUpdate hits if')
          this.props.receiveContact(null).then(() => {
            this.props.receiveContact(this.props.contact).then(() => {
              this.props.getContact(this.props.contactID).then(contact => {
                receiveContact(contact)
              })
            })
          })
        }
        this.handlePrediction()
      }

      componentWillUnmount() {
        this.props.receiveContact(null)
      }

      handlePrediction = () => {
        const { ingestPrediction, createContact, consumePrediction, inbox } =
          this.props

        if (!inbox && createContact?.entities?.length) {
          Promise.resolve(ingestPrediction(createContact.entities)).then(() =>
            consumePrediction('createContact'),
          )
        }
      }

      render() {
        return this.props.inbox ? (
          <div
            className={this.props.classes.content}
            // style={this.props.inbox ? { backgroundColor: '#fff' } : null}
            style={{ backgroundColor: '#fff' }}
          >
            <MobileForm mobile inbox contactID={this.props.contactID} />
            <AddDetailsModal />
          </div>
        ) : (
          <div
            className={this.props.classes.content}
            // style={this.props.inbox ? { backgroundColor: '#fff' } : null}
            style={{
              backgroundColor: '#fff',
              height: '100%',
              overflowY: 'scroll',
            }}
          >
            <Hidden smDown>
              <DesktopForm
                contactID={this.props.contactID}
                inbox={this.props.inbox}
                dialog={this.props.dialog}
              />
            </Hidden>
            <Hidden mdUp>
              <MobileForm
                mobile
                inbox={this.props.inbox}
                dialog={this.props.dialog}
                contactID={this.props.contactID}
              />
            </Hidden>
            <AddDetailsModal />
          </div>
        )
      }
    },
  ),
)
